var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "modal",
    attrs: { id: "duplicate-client-warning-modal" },
    on: { hidden: _vm.closingModal },
    scopedSlots: _vm._u([
      {
        key: "header-custom",
        fn: function () {
          return [
            _c("div", { staticClass: "d-flex flex-wrap" }, [
              _c("div", { staticClass: "vertical-center" }, [
                _c("h5", { staticClass: "modal-title bold" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("boards.messages.duplicateClient")) +
                      "\n        "
                  ),
                ]),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "row mx-0 align-items-center pb-3 w-100" },
              [
                _c("div", {
                  domProps: { innerHTML: _vm._s(_vm.matchingCaseToUse) },
                }),
              ]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "simple-button",
              {
                attrs: {
                  id: "create-application",
                  type: "button",
                  "class-name": "btn-sm btn-primary",
                },
                on: { click: _vm.createClient },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("global.actions.confirm")) +
                    "\n    "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }